import { createClient } from "@supabase/supabase-js";

const w = window as any;

const rawUrl =
  (import.meta.env?.VITE_SUPABASE_URL ??
    w.__ENV__?.VITE_SUPABASE_URL ??
    "").trim();

export const SUPABASE_URL = rawUrl.replace(/\/+$/, "");

export const SUPABASE_KEY = (
  import.meta.env?.VITE_SUPABASE_ANON_KEY ??
  import.meta.env?.VITE_SUPABASE_PUBLISHABLE_KEY ??
  w.__ENV__?.VITE_SUPABASE_ANON_KEY ??
  ""
).trim();

console.log("[SB] Env:", {
  VITE_SUPABASE_URL: SUPABASE_URL,
  HAS_ANON_OR_PUBLISHABLE: Boolean(SUPABASE_KEY),
});

// Additional validation logging
if (!SUPABASE_URL || !/^https:\/\//i.test(SUPABASE_URL)) {
  console.error("[SB] Invalid SUPABASE_URL:", SUPABASE_URL);
}
if (!SUPABASE_KEY) {
  console.error("[SB] Missing SUPABASE_KEY");
}

export const supabase =
  SUPABASE_URL && SUPABASE_KEY
    ? createClient(SUPABASE_URL, SUPABASE_KEY, { auth: { persistSession: false } })
    : null;
